import { StoreLocationOrGroupsType } from './store-location-or-groups.types';

export const locationOrGroupsTypeOptions: { label: string; value: StoreLocationOrGroupsType }[] = [
  {
    label: 'Store Location',
    value: 'storeLocation',
  },
  {
    label: 'Store Location Groups',
    value: 'storeLocationGroups',
  },
];
